import * as React from 'react';
import { cloneDeep, entries, parseInt } from 'lodash';
import { MessageTemplate } from '@interface/index';
import { NiCard, AddButton, NiForm, NiInput } from '@component/index';
import { API, USER_CHANNEL_NAME_MAP, RESPONSE_CHANNEL_TYPE, INTEGRATION_TYPE } from '@config/index';
import { Layout, message, Space, Tabs, Input, Spin, Modal, Typography, Checkbox } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { RouteComponentProps } from 'react-router-dom';
import reactJsonView from 'react-json-view';
const ReactJsonView = reactJsonView;

const { Content } = Layout;

import './index.less';

export type MessageTemplateCompProps = RouteComponentProps<{
}> & {};
export interface MessageTemplateCompState {
  channels: string[];
  channel: string;
  data: { [key: string]: MessageTemplate[] };
  loading: boolean;
  tabIndex: number;
  modalVisible: boolean;
  newKey: string;
  newValue: string;
  modalLang: string;
  searchText: string;
}
export class MessageTemplateComp extends React.Component<MessageTemplateCompProps, MessageTemplateCompState> {
  state: MessageTemplateCompState = {
    channels: Object.values(INTEGRATION_TYPE),
    channel: RESPONSE_CHANNEL_TYPE.RESTFUL,
    data: {},
    loading: false,
    tabIndex: 0,
    modalVisible: false,
    modalLang: '',
    newKey: '',
    newValue: '',
    searchText: ''
  };

  listener: (() => void) | undefined;

  componentDidMount() {
    this.onInit();
  }

  onInit = async () => {
    this.setState({ loading: true });

    try {
      const tmps: any = await API.messageTemplate.getAll();

      this.setState({ data: tmps });
    } catch (err) {
      message.error(err.message);
    } finally {
      this.setState({ loading: false });
    }
  }

  componentWillUnmount() {
    if (this.listener) {
      this.listener();
    }
  }

  render() {
    const state = this.state;
    const {
      channels,
      channel,
      data,
      loading,
      tabIndex,
      modalVisible,
      newKey,
      newValue,
      modalLang,
      searchText
    } = this.state;

    return (
      <Layout className="admin-layout"
      >
        <Spin spinning={loading}>
          <Content style={{ padding: 16, backgroundColor: 'white' }}>
            <Tabs
              style={{ backgroundColor: 'white' }}
              activeKey={channel}
              onChange={(activeKey: string) => {
                this.setState({ channel: activeKey });
              }}
              tabBarExtraContent={<AddButton
                onClick={() => {
                  this.addTemp({
                    type: 'Name Undefined',
                    channel_type: channel,
                    for_item: true,
                    for_list: true,
                    flavor: '',
                    template: '',
                    header_template: '',
                    footer_template: ''
                  });
                }}
              />}
            >{
                channels.map((channel: string) =>
                  <Tabs.TabPane key={channel} tabKey={channel} tab={USER_CHANNEL_NAME_MAP[channel]}>
                    {
                      (data[channel] || []).map((tmp: MessageTemplate, idx: number) =>
                        <NiCard
                          style={{ marginBottom: 16 }}
                          title={
                            <Typography.Text
                              editable={{
                                onChange: (value: string) => {
                                  const next = cloneDeep(tmp);
                                  next.type = value;
                                  this.updateTemp(next);
                                }
                              }}
                            >
                              {
                                tmp.type
                              }
                            </Typography.Text>
                          }
                          extra={<Space size={16}>
                            <Input
                              defaultValue={tmp.flavor}
                              placeholder="Flavor"
                              onBlur={(e: any) => {
                                tmp.flavor = e.target.value;
                                this.updateTemp(tmp);
                              }}
                            />
                            <Checkbox
                              checked={tmp.for_item}
                              onChange={(e: any) => {
                                const next = cloneDeep(tmp);
                                next.for_item = e.target.checked;
                                this.updateTemp(next);
                              }}
                            >For Item</Checkbox>
                            <Checkbox
                              checked={tmp.for_list}
                              onChange={(e: any) => {
                                const next = cloneDeep(tmp);
                                next.for_list = e.target.checked;
                                this.updateTemp(next);
                              }}
                            >For List</Checkbox>
                            <DeleteOutlined
                              onClick={() => {
                                this.deleteTemp(tmp);
                              }}
                            />
                          </Space>}
                        >
                          <NiForm
                            items={
                              tmp.for_list ?
                                [
                                  {
                                    key: 'header',
                                    label: 'Header',
                                    content: <NiInput.TextArea
                                      defaultValue={tmp.header_template}
                                      onBlur={(e: any) => {
                                        tmp.header_template = e.target.value;
                                        this.updateTemp(tmp);
                                      }}
                                    />
                                  },
                                  {
                                    key: 'body',
                                    label: 'Body',
                                    content: <NiInput.TextArea
                                      defaultValue={tmp.template}
                                      onBlur={(e: any) => {
                                        tmp.template = e.target.value;
                                        this.updateTemp(tmp);
                                      }}
                                    />
                                  },
                                  {
                                    key: 'footer',
                                    label: 'Footer',
                                    content: <NiInput.TextArea
                                      defaultValue={tmp.footer_template}
                                      onBlur={(e: any) => {
                                        tmp.footer_template = e.target.value;
                                        this.updateTemp(tmp);
                                      }}
                                    />
                                  }
                                ] : [
                                  {
                                    key: 'body',
                                    label: 'Body',
                                    content: <NiInput.TextArea
                                      defaultValue={tmp.template}
                                      onBlur={(e: any) => {
                                        tmp.template = e.target.value;
                                        this.updateTemp(tmp);
                                      }}
                                    />
                                  }
                                ]
                            }
                          />
                          {/* <ReactJsonView
                            src={tmp.template}
                            name={null}
                            displayObjectSize={false}
                            onEdit={(value: any) => {
                              tmp.template = value.updated_src;
                              this.updateTemp(tmp);
                            }}
                            onAdd={(value: any) => {
                              tmp.template = value.updated_src;
                              this.updateTemp(tmp);
                            }}
                            onDelete={(value: any) => {
                              tmp.template = value.updated_src;
                              this.updateTemp(tmp);
                            }}
                          /> */}
                        </NiCard>)
                    }
                  </Tabs.TabPane>
                )
              }
            </Tabs>
          </Content>
        </Spin>
      </Layout>
    );
  }

  updateTemp = async (tmp: MessageTemplate) => {
    this.setState({ loading: true });

    try {
      await API.messageTemplate.update(tmp);
      this.onInit();
    } catch (err) {
      message.warning(err.message);
    } finally {
      this.setState({ loading: false });
    }
  }

  addTemp = async (tmp: MessageTemplate) => {
    this.setState({ loading: true });

    try {
      await API.messageTemplate.add(tmp);
      this.onInit();
    } catch (err) {
      message.warning(err.message);
    } finally {
      this.setState({ loading: false });
    }
  }

  deleteTemp = async (tmp: MessageTemplate) => {
    this.setState({ loading: true });

    try {
      await API.messageTemplate.delete(tmp);
      this.onInit();
    } catch (err) {
      message.warning(err.message);
    } finally {
      this.setState({ loading: false });
    }
  }
}

export const MessageTemplatePage = (props: any) => {
  return <MessageTemplateComp {...props} />;
};

